import { useState, useEffect } from 'react';
import NavigationDrawer from '../../../../components/navigationDrawer';
import DynamicTable from '../../../../components/dynamicTable';
import { Container, Grid, TextField, Typography } from '@mui/material';
import orderStyle from './style';
import { useNavigate } from 'react-router-dom';
import { getAllOrdersByRestId } from './../../../../services/orders/index';
import Loader from '../../../../components/loader';
import moment from 'moment';
import { DateRangePicker } from 'react-dates';
import { getAllMatches } from '../../../../services/authentication';

const headerData = [
  {
    id: 'matchId',
    numeric: false,
    disablePadding: true,
    label: 'ID',
  },
  {
    id: 'Name',
    numeric: false,
    disablePadding: true,
    label: 'Name',
  },
  {
    id: 'date',
    numeric: false,
    disablePadding: true,
    label: 'Date',
  },
  {
    id: 'persons',
    numeric: true,
    disablePadding: false,
    label: 'Persons',
  },
  {
    id: 'actions',
    numeric: true,
    disablePadding: false,
    label: 'Actions',
  },
];

const rowsData = [
  {
    tripId: 1,
    date: moment(new Date()).format('DD-MM-YYYY hh:mm:ss A'),
    persons: 4,
    image:
      'https://thumbs.dreamstime.com/b/time-to-travel-wooden-sign-beach-background-49509295.jpg',
    email: 'test1@gmail.com',
    tripName: 'Somewhere',
    tripDetail: [
      {
        date: moment(new Date()).format('DD-MM-YYYY hh:mm:ss A'),
        image: require('../../../../assets/images/profile.png'),
        persons: 4,
        username: 'Jack',
        gender: 'Male',
        address: '1800 Ellis St, San Francisco, CA 94115, USA',
        phoneNumber: '123456789111',
        email: 'jack@gmail.com',
        tripName: 'Somewhere',
      },
      {
        date: moment(new Date()).format('DD-MM-YYYY hh:mm:ss A'),
        image:
          'https://i.pinimg.com/originals/7d/34/d9/7d34d9d53640af5cfd2614c57dfa7f13.png',
        persons: 4,
        username: 'Ella',
        gender: 'Female',
        address: '73 Elmwood St.Ponte Vedra Beach, FL 32082',
        phoneNumber: '123456789111',
        email: 'ella@gmail.com',
        tripName: 'Somewhere',
      },
      {
        date: moment(new Date()).format('DD-MM-YYYY hh:mm:ss A'),
        image: require('../../../../assets/images/profile.png'),
        persons: 4,
        gender: 'Male',
        username: 'Scarlett',
        address: '932 Thorne St. El Dorado, AR 71730',
        phoneNumber: '123456789111',
        email: 'scarlett@gmail.com',
        tripName: 'Somewhere',
      },
      {
        date: moment(new Date()).format('DD-MM-YYYY hh:mm:ss A'),
        image:
          'https://i.pinimg.com/originals/7d/34/d9/7d34d9d53640af5cfd2614c57dfa7f13.png',
        persons: 1,
        username: 'Hazel',
        address: '589 Snake Hill St. Largo, FL 33771',
        gender: 'Female',
        phoneNumber: '123456789111',
        email: 'hazel@gmail.com',
        tripName: 'Somewhere',
      },
    ],
  },
  {
    tripId: 2,
    date: moment(new Date()).format('DD-MM-YYYY hh:mm:ss A'),
    persons: 1,
    image:
      'https://image.shutterstock.com/image-vector/go-road-trip-vector-illustration-260nw-624096107.jpg',
    email: 'test1@gmail.com',
    tripName: 'Somewhere',
    tripDetail: [
      {
        date: moment(new Date()).format('DD-MM-YYYY hh:mm:ss A'),
        image: require('../../../../assets/images/profile.png'),
        persons: 1,
        address: '933 Vernon St. Long Beach, NY 11561',
        phoneNumber: '123456789111',
        username: 'Hudson',
        gender: 'Male',
        email: 'hudson@gmail.com',
        tripName: 'Somewhere',
      },
    ],
  },
  {
    tripId: 3,
    date: moment(new Date()).format('DD-MM-YYYY hh:mm:ss A'),
    persons: 2,
    image:
      'https://cdn.pixabay.com/photo/2016/07/30/00/03/winding-road-1556177__480.jpg',
    email: 'test1@gmail.com',
    tripName: 'Somewhere',
    tripDetail: [
      {
        date: moment(new Date()).format('DD-MM-YYYY hh:mm:ss A'),
        image: require('../../../../assets/images/profile.png'),
        address: '7131 Pineknoll Drive Bridgeton, NJ 08302',
        phoneNumber: '123456789111',
        gender: 'Male',
        persons: 2,
        username: 'Willow',
        email: 'willow@gmail.com',
        tripName: 'Somewhere',
      },
      {
        date: moment(new Date()).format('DD-MM-YYYY hh:mm:ss A'),
        image:
          'https://i.pinimg.com/originals/7d/34/d9/7d34d9d53640af5cfd2614c57dfa7f13.png',
        address: '1800 Ellis St, San Francisco, CA 94115, USA',
        phoneNumber: '123456789111',
        persons: 2,
        username: 'Madison',
        gender: 'Female',
        email: 'madison@gmail.com',
        tripName: 'Somewhere',
      },
    ],
  },
];

const diplayRows = ['tripId', 'tripName', 'date', 'persons', 'actions'];

const Trips = () => {
  const classes = orderStyle();
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem('user'));
  const [isLoading, setIsLoading] = useState(false);
  const [allMatches, setAllMatches] = useState([]);
  const [focus, setFocus] = useState(null);
  const [dateValues, setDateValues] = useState({
    startDate: null,
    endDate: null,
  });

  const handleOnDateChange = (startDate, endDate) => {
    let start = startDate.startDate;
    let end = startDate.endDate;
    setDateValues({
      startDate: start,
      endDate: end,
    });
  };

  useEffect(() => {
    setIsLoading(true);
    let tempArr=[]   
    getAllMatches()
      .then((res) => {
        setIsLoading(false);
        let data=res?.data?.data
        console.log(data,"data=====>>>>>>>");
        data.map((item,index)=>{
          tempArr.push({
            ...item,
            tripId:index+1,
            date:item?.tripDetails?.createdDate,
            tripName:item?.tripDetails?.plannedCity,
            persons:item?.users.length,
            tripDetails:item?.tripDetails,
            users:item?.users
          })
      })
        setAllMatches(tempArr);
      })
      .catch((err) => {
        console.log(err, "sdlaskdlsakj");
        setIsLoading(false);
      });
  }, []);

  const navigateToDetail = (row) => {
    navigate(`/matchDetail/${row.tripDetails?._id}`, {
      state: row,
    });
  };

  return (
    <NavigationDrawer>
      <Loader isloading={isLoading} />

      <Grid container alignItems='center' marginBottom={3}>
        <Grid item xs={12} md={2}>
          <Typography style={{ fontSize: '22px', fontWeight: '600' }}>
            Matches
          </Typography>
        </Grid>
      </Grid>
      <div style={{ textAlign: 'right', margin: '20px 0' }}>
        <DateRangePicker
          isOutsideRange={() => false}
          startDatePlaceholderText='Start Date'
          startDate={dateValues.startDate}
          onDatesChange={handleOnDateChange}
          endDatePlaceholderText='End Date'
          endDate={dateValues.endDate}
          numberOfMonths={2}
          displayFormat='DD-MM-YYYY'
          showClearDates={true}
          focusedInput={focus}
          onFocusChange={(focus) => setFocus(focus)}
          startDateId='startDateMookh'
          endDateId='endDateMookh'
          minimumNights={0}
          small
          showDefaultInputIcon={false}
        />
        <TextField
          style={{ marginLeft: 10 }}
          placeholder='Search'
          size='small'
        />
      </div>
      <DynamicTable
        headerData={headerData}
        bodyRows={allMatches}
        displayData={diplayRows}
        showView={true}
        navigateToDetail={navigateToDetail}
      />
    </NavigationDrawer>
  );
};

export default Trips;
